import { EventType } from "../../../enums/eventType";

/**
 * Filter option values that stand for more than one raw `event_type`.
 *
 * RISA-Assist activity is persisted as two separate event types (browser
 * actions and question/answer events), but users think of it as one source,
 * so the single "RISA-Assist" option expands to both.
 */
export const EventTypeFilterGroups: Record<string, EventType[]> = {
  [EventType.EXTENSION_SESSION]: [
    EventType.EXTENSION_ACTION,
    EventType.EXTENSION_QA,
  ],
};

/**
 * Builds the "Event Type" filter section for the view-all events table.
 *
 * @returns Filter section with one option per event source.
 */
export const createFilterBasedOnEventType = () => {
  return {
    id: "event_type",
    label: "Event Type",
    options: [
      { label: "API Call", value: EventType.API_CALL_DETAILS },
      { label: "RPA Actions", value: EventType.RPA_ACTIONS_DETAILS },
      { label: "User Action", value: EventType.FRONTEND_EVENT_DETAILS },
      { label: "RISA-Assist", value: EventType.EXTENSION_SESSION },
    ],
    type: "string" as const,
  };
};
